import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { StatoFascicoloEnum } from "../enum/stato-fascicolo-enum";
import { ClassificaDTO } from "./classificaDTO";
import { UtenteDTO } from "./utenteDTO";
import { VisibilitaFascicoloDTO } from "./visibilita-fascicoloDTO";
import { RiferimentiPosizioneDTO } from "./riferimento-posizioneDTO";
import { DocumentoDTO } from "./documentoDTO";
import { MetadatiRepertorioDTO } from "./metadati-repertorioDTO";

export class WrapperCollegamentoUnitaDocumentariaDTO {
  id: string;

  tipo: TipoSupportoDocumentoEnum;

  metadatiRepertorio: MetadatiRepertorioDTO;

  oggetto: string;

  segnaturaArchivistica: string;

  riferimentoPosizione: RiferimentiPosizioneDTO;

  dataInserimento: string;

  stato: string;

  classifica: ClassificaDTO;

  dataUltimaModifica: string;

  primario: DocumentoDTO;

  inseritoDa: UtenteDTO;

  visibilitaElemento: VisibilitaFascicoloDTO[];
}
